import axios from 'axios';
import { routes } from '../config';

const api = axios.create({
  baseURL: '',
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
  },
});


// Request interceptor to add Firebase token
api.interceptors.request.use((config) => {
  return config;
});

// Response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = routes.login;
    }
    return Promise.reject(error);
  }
);

export default api;
